<template lang="pug">
  div(v-if="page" :key="$route.params.slug")
    content-loader.mt-3(v-if="$wait.is('fetching help content')")
      circle(cx="8" cy="8" r="8")
      rect(x="24" y="5" width="120" height="6")
      rect(x="0" y="24" width="300" height="6")
      rect(x="0" y="36" width="280" height="6")
      rect(x="0" y="48" width="275" height="6")
    div(v-if="!$wait.is('fetching help content')")
      .d-flex.flex-row.align-items-center
        font-awesome-icon.help-page__icon(:icon="['far', page.post_icon]")
        h3.help-page__title {{ page.post_title }}
      div(v-html="page.content" v-if="!page.is_elementor")
      div(v-if="page.is_elementor")
        elementor-component(:object-id="page.ID" object-type="template")
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import ElementorComponent from '../../../components/ElementorComponent.vue';
import { RepositoryFactory } from '../../../repositoryFactory';

const BlogRepository = RepositoryFactory.get('blog');
export default {
  components: {
    ContentLoader,
    ElementorComponent,
  },
  mixins: [BreadcrumbsManager],
  data() {
    return {
      page: {},
    };
  },
  metaInfo() {
    return {
      title: this.page.post_title,
    };
  },
  watch: {
    $route() {
      this.page = {};
      this.getPage();
    },
  },
  mounted() {
    this.getPage();
  },
  methods: {
    async getPage() {
      this.$wait.start('fetching help content');
      const { data } = await BlogRepository.page().getBySlug(this.$route.params.slug).then((resp) => resp.data);
      this.page = data;
      this.setBreadcrumbs([
        { name: this.page.post_title },
      ]);
      this.$wait.end('fetching help content');
    },
  },
};
</script>
